var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnique(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12873 12.6205V8.08568C9.12873 7.91721 9.26626 7.77969 9.43472 7.77969H15.2657V6.88922C15.2657 6.70012 15.111 6.54541 14.9219 6.54541H4.70734C4.51824 6.54541 4.36353 6.70012 4.36353 6.88922V12.0017C4.36353 15.0134 6.80458 17.4545 9.81635 17.4545C10.5762 17.4545 11.3016 17.2998 11.9583 17.0179C10.2874 16.2546 9.12873 14.5734 9.12873 12.6205Z",
    fill: "#303030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7998 8.08578C18.7998 7.91731 18.6623 7.77979 18.4939 7.77979H15.2655V12.0018C15.2655 14.2537 13.9006 16.1859 11.9546 17.018C12.5666 17.2999 13.2473 17.4546 13.9659 17.4546C16.6373 17.4546 18.7998 15.2886 18.7998 12.6206V8.08578Z",
    fill: "#303030"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.818182,
    y: 0.818182,
    width: 22.3636,
    height: 22.3636,
    rx: 3.54545,
    stroke: "black",
    strokeWidth: 1.63636
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnique);
export default __webpack_public_path__ + "static/media/unique.fa47fb25af5ebc65349cffa25c10bcaf.svg";
export { ForwardRef as ReactComponent };